import { Guid } from "@/Common/Models/Guid";
import { FlowsheetClient } from "../Api/FlowsheetClient";
import { FlowsheetTemplateClient } from "../Api/FlowsheetTemplatesClient";
import { FlowsheetTemplate } from "../Models/FlowsheetTemplate";
import { IUseQueryResponse, useQuery } from "./useQuery";

function useAvailableFlowsheetTemplates({ encounterId, patientId }: { encounterId?: Guid, patientId: Guid }): IUseQueryResponse<FlowsheetTemplate[]> {
    return useQuery({
        query: async () => {
            const [templatesResponse, flowsheetsResponse] = await Promise.all([
                FlowsheetTemplateClient.getFlowsheetTemplates({ patientId, includeDefaultTemplates: true }),
                FlowsheetClient.findFlowsheetSummaries({ encounterId })
            ]);

            templatesResponse.throwIfError();

            const allTemplates = templatesResponse.data.Data.map(flowsheetTemplate => new FlowsheetTemplate(flowsheetTemplate));
            const encounterFlowsheets = flowsheetsResponse.Data;

            const availableTemplates = allTemplates?.filter(template =>
                !encounterFlowsheets?.some(flowsheet => flowsheet.Template.Id === template.Id)
            );

            return availableTemplates;
        },
        queryKey: [encounterId]
    });
}

export {
    useAvailableFlowsheetTemplates
};
